import { useEffect, useState } from 'react'
import {
    Dialog,
    DialogContent,
    TextField,
    Button,
    Slide,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { forwardRef } from 'react'
import { isValidEmail } from '../../../utils/CommonMethods'
import { buttonStyles } from '../../../styles/buttonStyles'


const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />
})

interface EditEmailDialogProps {
    open: boolean;
    onClose: () => void;
    email: string;
    onUpdate: (email: string) => void;
    emailList: string[];
}

export default function EditEmailDialog({
    open,
    onClose,
    email,
    onUpdate,
    emailList
}: EditEmailDialogProps) {
    const [emailValue, setEmailValue] = useState(email)
    const [emailError, setEmailError] = useState("");

    const handleUpdate = () => {
        onUpdate(emailValue)
        onClose()
    }
    useEffect(() => {
        setEmailValue(email)
    }, [email])

    useEffect(() => {
        const checkEmailvalidity = () => {
            const updatedEmailList = emailList.filter((emailItem) => emailItem !== email);
            const trimmedEmail = emailValue.trim().toLowerCase();
            if (trimmedEmail) {
                if (!isValidEmail(trimmedEmail)) {
                    setEmailError("Please enter a valid email address");
                } else if (updatedEmailList.includes(trimmedEmail)) {
                    setEmailError("Duplicate address. Add new address.");
                } else {
                    setEmailError("")
                }
            } else {
                setEmailError("Please type in an email address above before adding.");
            }
        }
        checkEmailvalidity()
    }, [emailValue])

    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    position: 'fixed',
                    bottom: 0,
                    m: 0,
                    borderRadius: '24px 24px 0 0',
                    maxWidth: '100%',
                    width: '100%',
                },
            }}
        >
            <DialogContent sx={{ p: 3 }}>
                <TextField
                    fullWidth
                    value={emailValue}
                    onChange={(e) => setEmailValue(e.target.value)}
                    variant="outlined"
                    error={!!emailError}
                    helperText={emailError}
                    sx={{
                        mb: 4,
                        color: "black",
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '30px',
                            bgcolor: '#F5F5F5',
                        },
                    }}
                />
                <Button
                    fullWidth
                    onClick={handleUpdate}
                    disabled={emailError.length > 0}
                    sx={{
                        ...buttonStyles.gradient,
                        py: 1.5,
                        borderRadius: '30px',

                    }}
                >
                    Update Email Address
                </Button>
            </DialogContent>
        </Dialog>
    )
}

